<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-container xl">
      <div class="button close">
        <span role="button" class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </span>
      </div>
      <div class="popup">
        <div class="popup-title">
          <p class="hdg02 mb8">{{data.product.name}}</p>
          <p class="txt-sup">ライセンスを付与したいアカウントにチェックを入れてください。<br>「アカウントの追加」より、新たにアカウントの作成が可能です。</p>
        </div>
        <div class="popup-content">
          <form @submit.prevent="state.search" class="contract-container">
            <div class="contract-content">
              <div class="contract-content-search">
                <div class="formparts search">
                  <FontawesomeIcon @click="state.search" :icon="['far','search']" size="2x" class="icn" />
                  <input type="text" placeholder="アカウント名" v-model="state.searchKeyword">
                </div>
                <p class="contract-content-search-register"><span v-if="!state.accountIsMax" class="txt-blue" @click="openCreate" role="button">アカウントの追加</span></p>
              </div>
              <div class="contract-content-info">
                <div class="contract-content-info-num">
                  <div class="contract-content-info-num-hdg">
                    <p>付与ライセンス数</p>
                    <p class="contract-content-info-num-hdg-txt"><span :class="[state.isMax && 'max']">{{state.checkBox.length}}</span> / <span>{{state.max}}</span></p>
                    <p>契約ライセンス数</p>
                  </div>
                </div>
              </div>
              <div class="tbl01 contract-content-table">
                <table class="tbl fixed-header">
                  <thead>
                    <tr>
                      <th>アカウント名</th>
                      <th class="ta-center w20">ライセンス期限</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(user, index) in state.filterdUser" :key="'user_' + index">
                      <th>
                        <div class="contract-content-table-group">
                          <div class="formparts checkbox">
                            <input type="checkbox" :value="user.id" :id="'user_' + index" v-model.number="state.checkBox" @click="action.beforeChange(user.id, $event)" @change="action.changeCheckbox">
                            <label role="button" :for="'user_' + index">
                              <FontawesomeIcon icon="check" class="icn" />
                              <span class="contract-content-table-group-label">{{user.name}}</span>
                            </label>
                          </div>
                        </div>
                      </th>
                      <td v-if="state.isCancel(user.id)" class="ta-center w20">{{formatDateKanji(data.product.period_end)}}</td>
                      <td v-else class="ta-center w20">ー</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="contract-submit">
                <div class="button contract-submit-button">
                  <button class="btn" type="button" @click="action.submit" name="button">決定</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'
import { ContractAssignLicenseForPackage } from '@/logic/contract/ContractAssignLicenseForPackage'

export default defineComponent({
  name: 'PCContractAssignLicenseForPackage',
  setup (props, context) {
    return { ...ContractAssignLicenseForPackage(props, context) }
  }
})
</script>

<style lang="scss" scoped>
.popup-wrapper{
  .popup-container{
    .popup-title{
      display: block;
      padding: 35px 116px 18px 40px;
      .txt{
        color: $color-sup;
      }
    }
  }
  .popup-content{
    padding: 30px 40px 40px;
  }
}
.contract {
  &-content {
    &-search {
      display: table;
      table-layout: fixed;
      width: 100%;
      .formparts.search {
        display: table-cell;
        vertical-align: middle;
        width: calc(100% - 175px);
        input[type=text]{
          height: 48px;
        }
      }
      &-register {
        font-size: 1.6rem;
        display: table-cell;
        vertical-align: middle;
        width: 175px;
        text-align: right;
      }
    }
    &-info {
      display: table;
      table-layout: fixed;
      width: 100%;
      margin: 22px 0 20px;
      &-notice {
        display: table-cell;
        vertical-align: bottom;
        font-size: 1.4rem;
        line-height: 1.57;
        color: $color-sup;
      }
      &-num {
        display: table-cell;
        vertical-align: bottom;
        text-align: right;
        padding: 0 18px;
        line-height: 1.57;
        &-hdg {
          display: flex;
          color: $color-sup;
          align-items: center;
          font-size: 1.4rem;
          float: right;
          p {
            margin-left: 12px;
          }
          &-txt {
            font-size: 2rem;
            color: $color-hdg;
            font-weight: bold;
            margin-top: -2px;
            .max {
              color: $color-highlight;
            }
          }
        }
      }
    }
    &-table{
      thead{
        th{
          background: $color-bg-paper;
          border-bottom: 0;
        }
      }
      tbody{
        th{
          border-top: 1px solid $color-line;
          text-align: left;
          padding: 20px 20px;
        }
        td{
          span.txt-blue + span.txt-blue{
            margin-left: 35px;
            padding-left: 20px;
            border-left: 1px solid $color-line;
          }
        }
      }
      &-group{
        display: flex;
        align-items: center;
        label{
          height: 20px;
        }
        .checkbox{
          &.is-disabled{
            label{
              pointer-events: none;
              svg {
                display: none;
              }
              &:after{
                width: 12px;
                border-bottom: 1px solid $color-link;
                top: 50%;
                border-radius: 0;
                position: absolute;
                height: 0;
                background: none;
                left: 4px;
              }
            }
          }
        }
        &-label{
          padding-left: 20px;
          border-left: 1px solid $color-line;
          line-height: 22px;
          display: inline-block;
          color: $color-link;
          margin-left: 8px;
        }
        .txt-sup{
          margin-left: 20px;
          margin-bottom: 0;
        }
      }
    }
  }
  &-submit {
    width: 210px;
    margin: 30px auto 0;
  }
}
.fixed-header {
  tbody {
    display: block;
    max-height: 330px;
    overflow-y: scroll;
  }
  thead,
  tbody tr {
    display: table;
    width: 100%;
  }
}
</style>
